import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import Row from 'react-bootstrap/Row';
import styles from './BannerIcon.module.scss';

export default function BannerIcon({ icon, link, text }: { icon: IconDefinition; link: string; text: string }) {
  return (
    <>
      <a className={`${styles.bannerIcon} d-none d-xl-block`} href={link} target="_blank" rel="noreferrer">
        <FontAwesomeIcon className={`${styles.icon} fa-fw`} icon={icon} />
        <div className={styles.text}>{text}</div>
      </a>
      <a className={`${styles.bannerIconSmall} d-xl-none`} href={link} target="_blank" rel="noreferrer">
        <Row className="align-items-center">
          <FontAwesomeIcon className={`${styles.icon} fa-fw`} icon={icon} />
          <div className={styles.text}>{text}</div>
        </Row>
      </a>
    </>
  );
}
